
// @ts-ignore
import {translate} from '@elements/translations';
import {defineComponent, watch, onMounted, ref} from 'vue';
import {getTicketConfig} from "~vue/utils/config-helper.ts";
import {useTicketStore} from '~vue/stores/TicketStore.ts';
import {storeToRefs} from 'pinia'
import CalendarLegend from "~vue/components/calendar/CalendarLegend.vue";
import PriceTable from "~vue/components/price-table/PriceTable.vue";
import DateList from "~vue/components/date-list/DateList.vue";
import {fetcher, assertData, getLocaleDateString} from "~vue/utils/utils.ts";
import {PriceGroupStruct, PriceStruct} from "~vue/utils/structs.ts";
import Error from "~vue/components/error/Error.vue";
import {getPriceGroupUrl, getDateListUrl} from "~vue/utils/urls.ts";

export default defineComponent({
    name: 'DateListView',
    components: {
        Error,
        PriceTable,
        DateList,
        CalendarLegend
    },
    emits: ['isLoading'],
    props: {
        defaultCatalogId: {
            type: String,
            required: false
        },
        defaultTicketId: {
            type: String,
            required: false
        }
    },
    setup(props, {emit}) {

        const ticketStore = useTicketStore();
        const {
            selectedDate,
            ticketPriceGroups,
            ticketPrices,
            hasDynamicPricing,
            selectedTicketType,
            selectedCatalogId,
            type,
            selectedTicketSubType
        } = storeToRefs(ticketStore);
        const {changeValidation, changeDate, changeTicketPriceGroups, changeHasDynamicPricing, changeAvailableTickets, changeTicketPrices, changeHasServices} = ticketStore;

        const showError = ref<boolean>(false);
        const errorMessage = ref<String>('');
        const priceGroups = ref<String[]>([]);
        const url = getDateListUrl(type.value, `/${selectedCatalogId.value ? selectedCatalogId.value : props.defaultCatalogId}/${selectedTicketSubType.value ? selectedTicketSubType.value : props.defaultTicketId}`);
        const isLoadingPrices = ref<boolean>(false);
        const isMobile = matchMedia('(max-width: 767px)').matches;

        const fetchPriceGroups = async () => {
            emit('isLoading', true);
            let url = getPriceGroupUrl(type.value, `/${selectedCatalogId.value}/${selectedTicketSubType.value}`);
            await fetcher(url).then((result) => {
                if(result.success) {
                    assertData(result, PriceGroupStruct, url, 'fetchPriceGroups', 'danger');
                    priceGroups.value = result.priceGroups;
                    showError.value = false;
                    errorMessage.value = '';

                    //prefill
                    if(ticketPriceGroups.value.length === 0) {
                        changeTicketPriceGroups(priceGroups.value);
                    }
                } else {
                    showError.value = true;
                    errorMessage.value = result.errorMessage;
                }
                emit('isLoading', false);
            }).catch((error) => {
                console.warn(error);
                emit('isLoading', false);
                showError.value = true;
            });
        }

        onMounted(() => {
            fetchPriceGroups();
        });


        return {
            translate,
            showError,
            url,
            changeDate,
            selectedDate,
            errorMessage,
            priceGroups,
            ticketPrices,
            changeHasDynamicPricing,
            changeTicketPrices,
            changeAvailableTickets,
            changeValidation,
            isLoadingPrices,
            changeHasServices,
            isMobile,
            emit,
            getLocaleDateString
        };
    }
});
